import { useMutation } from '@tanstack/react-query';
import { useToast } from '@bitrise/bitkit';
import { appWatchPath } from '@/utils/monolithApiRouteService';
import { monolithApi } from '@/utils/api';
import useInitialState from '@/hooks/useInitialState';

const useWatchApp = (appSlug: string, initialWatching: boolean) => {
  const [isWatching, setWatching] = useInitialState(initialWatching);
  const toast = useToast();

  const shouldWatch = !isWatching;

  const mutation = useMutation({
    mutationFn: () => {
      return monolithApi.post<{ shouldWatch: boolean }>(appWatchPath(appSlug), {
        shouldWatch,
      });
    },
    onSuccess: () => {
      setWatching(shouldWatch);
    },
    onError: () => {
      toast({
        description: `Failed to turn ${isWatching ? 'off' : 'on'} watching`,
        status: 'error',
        isClosable: true,
      });
    },
  });

  return {
    isWatching,
    isLoading: mutation.isPending,
    toggleWatching: () => mutation.mutate(),
  };
};

export default useWatchApp;
